import { render, staticRenderFns } from "./ShiftActionWarnings.vue?vue&type=template&id=574dd3d6&"
import script from "./ShiftActionWarnings.vue?vue&type=script&lang=ts&"
export * from "./ShiftActionWarnings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports